import { TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {  stringToDate } from 'src/utils/date-utils';
import React from 'react';
import { useAuth } from '../../hooks/useAuth';

type Props = {
    value: string,
    label: string,
    onChange: (updatedValue: string) => void
}

const CustomDatePickerNoError = ({ value, onChange, label }: Props) => {
    const { user } = useAuth();    
    const culture = user?.culture ?? 'en-US';
    const dateFormat = user?.dateFormat ?? 'M/D/YYYY';

    const onDateChange = (date: Date) => {
       
        try {
            const dateString = date.toISOString();
            onChange(dateString);
        }
        catch (err) {
            onChange('');
        }
    }

    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker label={label}
            inputFormat={dateFormat}
            value={stringToDate(value)}
            onChange={onDateChange}
            renderInput={(params) => <TextField {...params} size='small'  />} />
    </LocalizationProvider>
}

export { CustomDatePickerNoError }
export default CustomDatePickerNoError